// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_l5-0";